import { formatDate } from '@btime/helpers'
import React from 'react'

import { findReplyByQuestionId, getCourseByTemplateId, getReplyValue } from '../../_helpers/pdfHelpers'
import { useParentServiceOrder } from '../../_load/ParentServiceOrderLoader'
import Image from '../../../../../components/presentation/Image'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import Separator from '../../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'

const CertificateTemplate = ({ templateId }) => {
  const parentServiceOrder = useParentServiceOrder()
  const childrenServiceOrder = useServiceOrder()

  const name = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 41))
  const document = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 10))
  const dateTime = getReplyValue(findReplyByQuestionId(childrenServiceOrder.replies, 61))
  const period = formatDate('DD/MM/YYYY', dateTime)
  const courseHours = getReplyValue(findReplyByQuestionId(childrenServiceOrder.replies, 62))
  const place = getReplyValue(findReplyByQuestionId(childrenServiceOrder.replies, 63))

  const course = getCourseByTemplateId(templateId)

  return (
    <>
      <View
        pageBreakAfter
        style={{ minHeight: '18.5cm', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
      >
        <Grid justify="space-between">
          <Col>
            <Image src="/pdfs/bosi/certificates/logo-certificado.jpg" />
          </Col>
          <Col>
            <Text size={52} color="#194782" style={{ fontStyle: 'italic' }}>
              CERTIFICADO
            </Text>
          </Col>
          <Col width="250px">
            <Text align="right" size={10}>
              Número de registro: 451-a
            </Text>
          </Col>
        </Grid>
        <Separator weight={18} />
        <Grid>
          <Col>
            <Text size={24} align="justify" style={{ lineHeight: '30px', fontStyle: 'italic' }}>
              {`Certificamos que, ${name} – CPF ${document} participou do treinamento `}
              <b>“{course.name}”</b>, com aprovação atingindo a média geral ponderada de aproveitamento.
            </Text>
          </Col>
        </Grid>
        <Separator weight={12} />
        <Grid>
          <Col width="50%">
            <Text size={22}>
              <strong>Período:</strong> {period}
            </Text>
            <Text size={22}>
              <strong>Local:</strong> {place}
            </Text>
          </Col>
          <Col width="50%">
            <Text size={22} align="right">
              <strong>Carga Horária:</strong> {`${courseHours}h`}
            </Text>
          </Col>
        </Grid>
        <Separator weight={12} />
        <Grid justify="center">
          <Col width="50%">
            <Text size={18} align="center" bold>
              __________________________________________
            </Text>
            <Text size={18} align="center" style={{ fontWeight: '700' }}>
              {name}
            </Text>
            <Text size={18} align="center">
              <strong>CPF:</strong> {document}
            </Text>
          </Col>
        </Grid>

        <Separator weight={12} />

        <Grid>
          <Col width="50%">
            <Grid justify="center">
              <Image src="/pdfs/bosi/certificates/assinatura-certificado-01.jpg" />
            </Grid>
          </Col>
          <Col width="50%">
            <Grid justify="center">
              <Image src="/pdfs/bosi/certificates/assinatura-certificado-02.jpg" />
            </Grid>
          </Col>
        </Grid>

        <Separator weight={18} />

        <Grid justify="center">
          <Col>
            <Text size={16} align="center" color="#194782" style={{ fontStyle: 'italic' }}>
              RFP – CONSULTORIA, TREINAMENTO E DESENVOLVIMENTO PROFISSIONAL
            </Text>
            <Text size={16} align="center" color="#194782" style={{ fontStyle: 'italic' }}>
              ROBERSON FÉLIX PEREIRA - MEI CNPJ – 30.471.335/0001-59
            </Text>
          </Col>
        </Grid>
      </View>

      <View
        pageBreakAfter
        style={{ minHeight: '18.5cm', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
      >
        <Grid>
          <Col gutter={8}>
            <Text size={18} style={{ fontWeight: '700', fontStyle: 'italic' }}>
              I) Conteúdo programático:
            </Text>
            <div style={{ paddingLeft: '20px' }}>
              <Separator weight={4} />
              {course.content.map(item => {
                return (
                  <>
                    <Text size={16} style={{ fontWeight: '700', fontStyle: 'italic' }}>
                      {item}
                    </Text>
                  </>
                )
              })}
            </div>
          </Col>
        </Grid>
      </View>
    </>
  )
}

export default CertificateTemplate
